'use client';

import { useEffect, useState } from 'react';
import Image from "next/image";

const LoadingScreen = ({ fullscreen = true }: { fullscreen?: boolean }) => {
  const [opacity, setOpacity] = useState(0);
  const [passThrough, setPassThrough] = useState(false);

  useEffect(() => {
    // Efekt płynnego pojawienia się ekranu ładowania
    setOpacity(0);
    const timer = setTimeout(() => {
      setOpacity(1);
    }, 10);

    // After 3s, allow clicks to pass through the overlay
    const escapeTimer = fullscreen ? setTimeout(() => {
      setPassThrough(true);
    }, 3000) : undefined;

    return () => {
      clearTimeout(timer);
      if (escapeTimer) clearTimeout(escapeTimer);
    };
  }, [fullscreen]);

  return (
    <div className={`${fullscreen ? 'fixed top-0 left-0 w-full h-full z-50' : 'w-full h-full'}
                     bg-gradient-to-b from-blue-50 to-blue-200
                     flex flex-col items-center justify-center overflow-hidden
                     transition-opacity duration-300 ease-in-out`}
         style={{ opacity, pointerEvents: passThrough ? 'none' : 'auto' }}>
      {/* Logo */}
      <div className="w-48 h-48 relative mb-8 animate-pulse">
        <Image
          src="/images/logoczerwone.webp"
          alt="Logo Szkolenia Morskie"
          fill
          className="object-contain"
          priority
        />
      </div>
      
      {/* Tekst ładowania */}
      <div className="text-[rgb(6,40,95)] text-xl font-medium mb-12">
        Ładowanie strony...
      </div>
      
      {/* Nowa animacja fal wodnych */}
      <div className="relative w-full max-w-md h-24">
        <div className="waves-container">
          <svg className="waves" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 24 150 28" preserveAspectRatio="none" shapeRendering="auto">
            <defs>
              <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
            </defs>
            <g className="parallax">
              <use xlinkHref="#gentle-wave" x="48" y="0" fill="rgba(0, 65, 125, 0.7)" />
              <use xlinkHref="#gentle-wave" x="48" y="3" fill="rgba(0, 65, 125, 0.5)" />
              <use xlinkHref="#gentle-wave" x="48" y="5" fill="rgba(0, 65, 125, 0.3)" />
              <use xlinkHref="#gentle-wave" x="48" y="7" fill="rgba(0, 65, 125, 0.2)" />
            </g>
          </svg>
        </div>
      </div>
      
      {/* Stylizacja CSS dla animacji */}
      <style jsx global>{`
        .waves-container {
          position: relative;
          width: 100%;
          height: 100%;
          overflow: hidden;
        }
        
        .waves {
          position: absolute;
          bottom: 0;
          width: 100%;
          height: 100%;
          margin-bottom: -7px; 
          min-height: 70px;
          max-height: 100px;
        }
        
        .parallax > use {
          animation: move-forever 25s cubic-bezier(.55,.5,.45,.5) infinite;
        }
        
        .parallax > use:nth-child(1) {
          animation-delay: -2s;
          animation-duration: 7s;
        }
        
        .parallax > use:nth-child(2) {
          animation-delay: -3s;
          animation-duration: 10s;
        }
        
        .parallax > use:nth-child(3) {
          animation-delay: -4s;
          animation-duration: 13s;
        }
        
        .parallax > use:nth-child(4) {
          animation-delay: -5s;
          animation-duration: 20s;
        }
        
        @keyframes move-forever {
          0% {
            transform: translate3d(-90px,0,0);
          }
          100% { 
            transform: translate3d(85px,0,0);
          }
        }
      `}</style>
    </div>
  );
};

export default LoadingScreen; 